'use client';

import { toast as sonnerToast } from 'sonner';
import { event_toast_error } from './gtm';

const toastError = (message, options) => {
  if (typeof message === 'string' && message.trim()) {
    event_toast_error({
      error_message: message.trim(),
      error_type: 'UI Error',
    });
  }

  return sonnerToast.error(message, options);
};

export const toast = Object.assign(
  (...args) => sonnerToast(...args),
  sonnerToast,
  { error: toastError }
);
